import { GovEmpty, GovIcon } from '@gov-design-system-ce/react';
import type { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import type { ServiceCode } from '@gov-nx/module/service';

interface ErrorStatusBannerProps {
	code: ServiceCode | PageCode | LocalizeNameSpaceTypes.Global;
	headline?: string;
	text?: string;
	className?: string;
}

export const ErrorStatusBanner = ({
	code,
	headline,
	text,
	className,
}: ErrorStatusBannerProps) => {
	const { t } = useLocale(code);

	return (
		<div className="p-(--templates-margin-l) bg-(--background-status-warning) rounded-(--corner-radius-l)">
			<GovEmpty
				align="center"
				size="l"
				headline={
					<p slot="headline">{headline ?? t('stav.chyba.musime-to-opravit')}</p>
				}
				icon={
					<GovIcon
						slot="icon"
						name="error"
						type="colored"
						className="bg-(--background-block-primary)!"
					/>
				}
				className={className}>
				<p className="text-(--text-primary) text-center">
					{text ?? t('stav.chyba.pracujeme-na-modernizaci')}
				</p>
			</GovEmpty>
		</div>
	);
};
